module.exports = __webpack_public_path__ + "img/po-article.823b13ce.png";